import React from "react"
import "./Privacy.css"

function Privacy() {
  return (
    <div className='Privacy'>
      <div>
        <h1>Privacy Policy</h1>
        <p className='last-updated'>
          Last Updated: {new Date().toLocaleDateString()}
        </p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to 528 Entertainment SJ ("we," "our," or "us"). We are
            committed to protecting your privacy and ensuring you have a
            positive experience while using our services. This Privacy Policy
            explains how we collect, use, disclose, and safeguard your
            information when you use our mobile application and related
            services.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>

          <h3>2.1 Information You Provide</h3>
          <p>
            We may collect information that you voluntarily provide to us,
            including:
          </p>
          <ul>
            <li>Name and contact information (email address, phone number)</li>
            <li>Account credentials</li>
            <li>Reservation and booking information</li>
            <li>
              Payment information (processed securely through third-party
              payment processors)
            </li>
            <li>Communications with our customer service</li>
          </ul>

          <h3>2.2 Automatically Collected Information</h3>
          <p>When you use our app, we may automatically collect:</p>
          <ul>
            <li>
              Device information (device type, operating system, unique device
              identifiers)
            </li>
            <li>
              Usage data (features accessed, time spent in app, interactions)
            </li>
            <li>Location information (if you grant permission)</li>
            <li>Analytics data (app performance, crash reports)</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use the collected information for the following purposes:</p>
          <ul>
            <li>To provide, maintain, and improve our services</li>
            <li>To process reservations and bookings</li>
            <li>
              To communicate with you about your account, reservations, and
              promotional offers
            </li>
            <li>To personalize your experience</li>
            <li>To analyze usage patterns and improve our app</li>
            <li>To ensure security and prevent fraud</li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>4. Information Sharing and Disclosure</h2>
          <p>
            We do not sell your personal information. We may share your
            information only in the following circumstances:
          </p>
          <ul>
            <li>
              <strong>Service Providers:</strong> With third-party service
              providers who assist us in operating our app and conducting our
              business
            </li>
            <li>
              <strong>Business Transfers:</strong> In connection with a merger,
              acquisition, or sale of assets
            </li>
            <li>
              <strong>Legal Requirements:</strong> When required by law or to
              protect our rights and safety
            </li>
            <li>
              <strong>With Your Consent:</strong> When you have given us
              explicit permission to share your information
            </li>
          </ul>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to
            protect your personal information against unauthorized access,
            alteration, disclosure, or destruction. However, no method of
            transmission over the Internet or electronic storage is 100% secure,
            and we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>6. Your Rights and Choices</h2>
          <p>
            You have the following rights regarding your personal information:
          </p>
          <ul>
            <li>
              <strong>Access:</strong> Request access to your personal
              information
            </li>
            <li>
              <strong>Correction:</strong> Request correction of inaccurate
              information
            </li>
            <li>
              <strong>Deletion:</strong> Request deletion of your personal
              information
            </li>
            <li>
              <strong>Opt-out:</strong> Opt-out of marketing communications
            </li>
            <li>
              <strong>Location:</strong> Manage location permissions through
              your device settings
            </li>
          </ul>
          <p>
            To exercise these rights, please contact us using the information
            provided in the Contact section below.
          </p>
        </section>

        <section>
          <h2>7. Children's Privacy</h2>
          <p>
            Our services are not directed to children under the age of 13. We do
            not knowingly collect personal information from children under 13.
            If you believe we have collected information from a child under 13,
            please contact us immediately.
          </p>
        </section>

        <section>
          <h2>8. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page
            and updating the "Last Updated" date. You are advised to review this
            Privacy Policy periodically for any changes.
          </p>
        </section>

        <section>
          <h2>9. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us:
          </p>
          <ul>
            <li>Email: support@528entertainment.com</li>
            <li>Customer Service: Via Google Business Chat or WeChat</li>
            <li>
              Address: 528 Entertainment SJ, 1715 Lundy Ave, Ste 138, San Jose,
              CA 95131
            </li>
          </ul>
        </section>
      </div>
    </div>
  )
}

export default Privacy
